<template>
  <div class="modal fade slide-right"
       id="cashingModal"
       role="dialog"
       aria-hidden="true"
       data-backdrop="static">
    <div class="modal-dialog modal-sm modal-payment" style="width: 35%;">
      <!-- v-if="block && modal && paymentStatus && total" -->
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-header clearfix text-left">
            <button type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-hidden="true">
              <i class="pg-close fs-14"
                 @click="cancel"></i>
            </button>
            <div class="col-md-12 modal-left">
              <h2 class="modal-title"
                  v-text="cashing.decoded_type"></h2>
            </div>
          </div>
          <div class="modal-body">
            <div class="col-md-12 modal-right">

              <h4>{{(cashing.ttc_amount / 100).toFixed(2)}} €</h4>

              <label>Séléctionner un mode de paiement</label>
              <custom-select :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="update_selected_method">
              </custom-select>

              <div class="text-center agency-payment-zone"
                   v-if="finalModal != null && finalBlock != null" style="margin-top: 15px;">
                <h4 v-text="finalModal.form.title"></h4>
                <section class="m-10"
                         v-html="finalModal.form.content"></section>
                <notifications v-if="any_errors"></notifications>
                <resource-form v-if="renderForm"
                               ref="paymentForm"
                               :schema="finalModal.form.schema"
                               :model="finalModal.form.model"
                               :realtimeUpdate="true"
                               :submit-button="false"
                               :customNotif="true">
                </resource-form>
                <div class="text-center agency-payment-zone">
                  <span v-text="finalModal.after_form_text"></span>
                  <button class="btn btn-complete btn-cons"
                          @click.prevent="onPaymentConfirmation">Confirmer</button>
                  <button type="button"
                          class="btn btn-default btn-cons no-margin inline"
                          data-dismiss="modal"
                          @click="cancel">Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex"
  import ResourceForm from 'components/Forms/ResourceForm'
  import cookies from 'cookiesjs'
  import Select2 from "components/Form/Select2"
  import CustomSelect from "components/Forms/Elements/Select"

  import Notifications from "./Notifications"
  export default {
    name: "CashModal",

    props: ["cashing"],

    components: {
      ResourceForm,
      Select2,
      CustomSelect,
      Notifications
    },


    mounted () {
      $(this.$el).modal()
      this.customerCashingsPaymentMethods(this.cashing_created_and_waiting_for_payment.id)
    },

    beforeDestroy () {
      $(this.$el).modal('hide')
      $('body').removeClass('modal-open')
      $('.modal-backdrop').remove()
    },

    data () {
      return {
        selected_method: null,
        modal: null,
        block: null
      }
    },

    watch: {
      selected_method: function (newv, oldv) {
        if (this.customer_cashings_payment_methods) {
          this.modal = null
          this.block = null
          this.reset_errors()
          this.$forceUpdate()
          this.$nextTick(() => {
            if (this.customer_cashings_payment_methods[newv] != undefined) {
              this.modal = this.customer_cashings_payment_methods[newv].modal
              this.block = this.customer_cashings_payment_methods[newv].block
              this.$forceUpdate()
            }
          })
        }
      },
    },

    computed: {
      ...mapGetters("cash", ["any_errors", "errors"]),

      renderForm () {
        return !_.isEmpty(this.finalModal.form.schema)
      },

      finalModal () {
        if (this.selected_method != null) {
          return this.modal
        }
      },

      finalBlock () {
        if (this.selected_method != null) {
          return this.block
        }
      },

      ...mapState('cash', ["customer_cashings_payment_methods", "cashings", "cashing_created_and_waiting_for_payment"]),
      ...mapGetters("cash", ["errors", "any_errors"]),


      normalizedPaymentMethod () {
        if (this.customer_cashings_payment_methods) {
          var cpy = _.clone(this.customer_cashings_payment_methods)
          var res = (_.map(cpy, function (pm, idx) { return ({ id: idx, name: pm.block.title, validation_method: pm.modal.form.model.validation_method }) }))
          return res
        }
      },

      fields() {
        let npm = _.concat([{id:4, name:"Paiement en ligne"}], this.normalizedPaymentMethod)
        let v = [
          {
            values:npm, multiple:false, placeholder:"",
            disabled:false, idx:0, required:false, value:this.selected_method, label:"",type:"select"
          },
        ]
        return v
      }
    },

    methods: {
      ...mapActions('cash', ["customerCashingsPaymentMethods", "sendPayment", "customerCashings", "fetchSingleCustomer", "clearCashingInStandBy","reset_errors"]),

      cancel () {
        this.reset_errors()
        this.$emit('close-cash-payment', true)
      },

      onPaymentConfirmation () {
        const data = this.renderForm ?
          this.$refs.paymentForm.dataToSend() : null
        var tmp_data = {
          customer_cashing_id: this.cashing.id,
          params: {
            customer_cashing_id: this.cashing.id,
            validation_method: this.normalizedPaymentMethod[this.selected_method].validation_method,
            payment_method: this.normalizedPaymentMethod[this.selected_method].validation_method,
          }
        }
        if (data != null) {
          _.assign(tmp_data.params, {
            method_specific_reference: data.method_specific_reference,
            reception_date: data.reception_date,
            check_name: data.check_name,
            check_issue_date: data.check_issue_date
          })
        }
        this.reset_errors()
            .then(() =>
                this.sendPayment(tmp_data)
                  .then(() => {
                    if (this.cashing_created_and_waiting_for_payment == null)
                      this.customerCashings()
                        .then(() => {
                          this.$emit('close-modal-after-success')
                        })
                  })
                )
      },

      update_selected_method(event) {
        if (event && event.new_value) {
          if (4 === event.new_value.value) {
            this.redirectToHostedCheckout()
          } else {
            this.selected_method = event.new_value.value
          }
        } else {
          this.selected_method = null
        }
      },

      redirectToHostedCheckout() {
        const params = {
          token: cookies('token'),
          origin_url: 'AGENCY_SPACE_URL',
          route_name: this.$route.name,
          locale: navigator.language,
          timezoneOffsetUtcMinutes: (new Date).getTimezoneOffset(),
          browserColorDepth: screen.colorDepth,
          browserScreenHeight: screen.height,
          browserScreenWidth: screen.width
        }

        if ('customer' === this.$route.name) {
          params.route_id = this.$route.params.id
          params.tab = 'cashings'
        }

        const urlParamsForPHP = $.param(params)

        window.location = `${__API_URL__}/customer_cashings/${this.cashing.id}/hosted_checkout_page?${urlParamsForPHP}`
      }
    },
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// client/components/Cash/CashModal.vue